import {
  Button,
  Heading,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { url } from "api";
import moment from "moment";
import {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { RootReducer } from "RootReducer";
import {
  CURRENT_MONTH,
  CURRENT_YEAR,
  MONTHS,
  YEARS,
} from "views/admin/profile/components/dateValues";

type InvoiceModalProps = {
  onClose: () => void;
};

const InvoiceModal = ({ onClose }: InvoiceModalProps) => {
  const companyName = useSelector(
    (state: RootReducer) => state.authentication.accountInfo.companyName
  );
  const companies = useSelector(
    (state: RootReducer) => state.authentication.accountInfo.companies
  );
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const toast = useToast();

  const [month, setMonth] = useState<string>((Math.max(CURRENT_MONTH - 1, 1)).toString());
  const [year, setYear] = useState<string>(CURRENT_YEAR.toString());
  const [company, setCompany] = useState<string | null>(null);

  useEffect(() => {
    if (companies && companies.length>0) {
      setCompany(companies[0].id);
    }
  }, [setCompany, companies])

  const handleInvoiceDownload = async () => {
    const token = localStorage.getItem("jwtToken");

    if (!month || !year) {
      toast({
        title: "Error",
        description: "Please select valid date range.",
        status: "error",
      });
      return;
    }
    const endDayOfGivenMonth = moment([Number(year), Number(month) - 1])
      .endOf("month")
      .format("DD");
    const fromDate = `${year}-${month}-01`;
    const untilDate = `${year}-${month}-${endDayOfGivenMonth}`;

    try {
      const response = await fetch(url + "/dashboard/invoice", {
        method: "POST",
        headers: {
          Accept: "application/pdf",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          from: fromDate,
          until: untilDate,
          partnerCompanyId: company,
        }),
      });
      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);

      let invoiceCompanyName = companyName

      if (company) {
        const subCompany = companies.find((c) => c.id === company)

        invoiceCompanyName = invoiceCompanyName+'_'+subCompany.companyName
      }

      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = `Invoice_${invoiceCompanyName}_${year}_${month}.pdf`;
      alink.click();
      toast({
        title: "Success",
        description: "Your invoice is ready and downloaded.",
        status: "success",
      });
      onClose();
    } catch (error) {
      if (process.env.NODE_ENV === "development") console.log(error);
    }
  };

  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading color={textColorPrimary} fontWeight="bold" fontSize="2xl" mt={2}>
            Select Invoice Period
          </Heading>
        </ModalHeader>
        <ModalBody>
          <SimpleGrid
            columns={1}
            backgroundColor={"#f8f4ff"}
            px={4}
            py={1}
            borderRadius={4}
            alignItems="center"
          >
            <SimpleGrid columnGap={4} columns={companies.length > 0 ? 3 : 2}>
              {companies.length > 0 && (
              <Select
                backgroundColor={"white"}
                //placeholder="Year"
                value={company}
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
              >
                {companies.map((info) => (
                  <option value={info.id}>{info.companyName}</option>
                ))}
              </Select>
              )}
              <Select
                backgroundColor={"white"}
                placeholder="Year"
                value={year}
                onChange={(e) => {
                  setYear(e.target.value);
                  setMonth(undefined);
                }}
              >
                {YEARS.map((year) => (
                  <option value={year}>{year}</option>
                ))}
              </Select>
              <Select
                backgroundColor={"white"}
                placeholder="Month"
                value={month ?? ""}
                onChange={(e) => setMonth(e.target.value)}
                disabled={!year}
              >
                {MONTHS.map((month) =>
                  Number(year) === CURRENT_YEAR &&
                  Number(month) > CURRENT_MONTH ? null : (
                    <option value={month}>{month}</option>
                  )
                )}
              </Select>
            </SimpleGrid>
          </SimpleGrid>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={handleInvoiceDownload}
            style={{
              marginRight: "10px",
              color: "white",
              borderColor: "#4a34ff",
              borderWidth: 2,
              backgroundColor: "#4a34ff",
            }}
            disabled={!month || !year}
            variant="solid"
            size="lg"
          >
            <Text>Download Invoice</Text>
          </Button>
          <Button
            onClick={onClose}
            style={{
              borderColor: "#4a34ff",
              borderWidth: 2,
              color: "#4a34ff",
            }}
            variant="solid"
            size="lg"
          >
            <Text>Cancel</Text>
          </Button>
        </ModalFooter>
      </ModalContent>
    </>
  );
};

export default InvoiceModal;
